<template>
  <div class="slide-sidebar-container__container">
    <div class="slide-sidebar-container__header">
      <div class="slide-sidebar-container__header-content">
        <div class="slide-sidebar-container__header-content-top">
          <button
            class="slide-sidebar-container__button"
            @click="slideSidebarBack"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
              <g clip-path="url(#clip0_84_7771)">
                <path d="M3.825 9.5L9.425 15.1L8 16.5L0 8.5L8 0.5L9.425 1.9L3.825 7.5H16V9.5H3.825Z" fill="#DEE3F0"/>
              </g>
              <defs>
                <clipPath id="clip0_84_7771">
                  <rect width="16" height="16" fill="white" transform="translate(0 0.5)"/>
                </clipPath>
              </defs>
            </svg>
          </button>

          <div class="slide-sidebar-container__header-title">
            <slot name="title" />
          </div>
        </div>
      </div>
    
      <hr class="slide-sidebar-container__header-divider" />

      <div
          v-if="$slots.subtitle"
          class="slide-sidebar-container__header-subtitle"
        >
        <slot name="subtitle" />
      </div>
    </div>

    <div class="slide-sidebar-container__body">
      <div class="slide-sidebar-container__content">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    methods: {
      ...mapActions('slideSidebar', [
        'slideSidebarBack'
      ]),
    }
  }
</script>

<style scoped lang="scss">
  @import "~@/assets/sass/variables";

  .slide-sidebar-container {
    &__container {
      position: fixed;
      display: flex;
      flex-direction: column;
      top: 0;
      right: 0;
      width: 400px;
      height: 100vh;
      background-color: $purple600;
      box-shadow: -11px 0 10px 0px rgba(#000, .05);
      z-index: 1000;
      overflow: hidden;
      padding: 24px;

      @media (max-width: 550px) {
        width: 100vw!important;
      }
    }

    &__button {
      padding-right: 8px;
      margin-top: -3px;

      svg { 
        width: 15px; 
        fill: lighten(#000, 50%) 
      }
    }
    
    &__header {
      z-index: 10;

      &-content {
        flex: 1;

        &-top {
          display: flex;
          gap: 10px;
          padding: 16px 8px;
        }
      }

      &-title {
        display: flex;
        align-items: center;
        width: 100%;
        font-size: 0.89rem;

        svg {
          width: 20px;
          height: 20px;
          margin-right: 5px;
          fill: $highlightPrimaryColor;
        }
      }

      &-subtitle {
        padding: 8px 0;
        color: $highlightPrimaryColor;

        strong {
          color: $highlightPrimaryColor;
        }
      }

      &-divider {
        margin-top: 0;
        margin-bottom: 8px;
        border: 1px solid $white20;
      }
    }

    &__body {
      position: relative;
      flex: 1;
      overflow: auto;
    }

    &__content {
      position: relative;
      min-height: 100%;
    }
  }
</style>